import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import { TripStatus } from "app/common/enums/trip-status.enum";

// Generar la lista de grupos para el combo
export function getGroupsList<T>(
  data: { group: BusinessPartnerGroupAttributes; shipTo: T[] }[],
  getGeoPoint: (shipTo: T) => number[] | undefined
): BusinessPartnerGroupAttributes[] {
  const seenIds = new Set<string>();

  return data
    // 1. Solo grupos con shipTo válido
    .filter(group =>
      (group.shipTo || []).some(shipTo =>
        getGeoPoint(shipTo)?.length > 0
      )
    )
    .map(group => group.group)
    .filter(group => group && !seenIds.has(String(group._id)) && seenIds.add(String(group._id)));
}

export function statusIdTrip(status: number): {
    color: string;
  } {
    switch (status) {
      case TripStatus.ABIERTO:
        return {
          color: "yellow",
        };
      case TripStatus.CARGANDO:
        return {
          color: "blue",
        };
      case TripStatus.EN_PROCESO:
        return {
          color: "green",
        };
      case TripStatus.CERRADO:
        return {
          color: "gray",
        };
      case TripStatus.LIQUIDANDO:
        return {
          color: "purple",
        };
      case TripStatus.DOC_LIQUIDACION_CREADO:
        return {
          color: "purple",
        };
      case TripStatus.DOC_LIQUIDACION_APROBADO:
        return {
          color: "purple",
        };
      case TripStatus.FINALIZADO:
        return {
          color: "green",
        };
      default:
        return {
          color: "gray",
        };
    }
  }